module.exports = __webpack_public_path__ + "img/dbfe7889e3b1276af6055b9c45df8a28.png";